const download = (blob: Blob, name: string, extension: string) => {
  try {
    const encodedUri = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `${name}.${extension}`);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    return true;
  } catch (e) {
    return false;
  }
};

export const downloadData = (data: any, name: string, extension: string) => {
  const blob = new Blob([JSON.stringify(data)]);
  download(blob, name, extension);
};

export const downloadBlob = (blobData: Blob, name: string, extension: string) => {
  download(blobData, name, extension);
};
